import React, { ReactElement } from 'react';
import { TFunction, withTranslation } from 'react-i18next';
import { ToastContainer } from "react-toastify";
import "./pageNew.scss";
import { UtilService } from '../../services/UtilService';
import { useLayout } from '../layout/LayoutContext'; 

interface IProps {
    children: ReactElement;
    t: TFunction
}


const Page: React.FC<IProps> = ({ children, t }) => {
    const { isMenuCollaped } = useLayout();
    const narrow = !isMenuCollaped();

    return (
        <div className={`page-container page-new${narrow ? " page-container--narrow" : ""}`}>
            <div {...UtilService.isMobilePlatform() ? { className: "container-fluid" } : { className: "container-fluid main-container pe-0" }}>
                <ToastContainer autoClose={3000} />
                <div className="header-margin"></div>
                {children}
            </div>
        </div>
    );
};

export default withTranslation()(Page);
